import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FaImages } from "react-icons/fa";

function GalleryButton() {
  const navigate = useNavigate();
  return (
    <>
      <button
        className="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-medium text-white transition duration-300 ease-out bg-[#df670e] rounded-xl shadow-lg hover:scale-105 hover:shadow-xl"
        onClick={() => navigate("/blogs")}
      >
        <FaImages className="mr-2 text-lg transition-transform duration-300 group-hover:rotate-12" />
        View Gallery
        <FontAwesomeIcon icon={faArrowRight} className="ml-1" />
      </button>
    </>
  );
}

export default GalleryButton;
